import common from './modules/common'
import sys from './modules/sys'
import dataview from './modules/dataview'
import notice from './modules/notice'
import userGroup from './modules/userGroup'
import analysis from './modules/analysis'
import visualizer from './modules/visualizer'
import userInfo from './modules/userInfo'

import {actions, mutations} from './constants'
import {util} from '../utils'
import _ajax from './ajax'

export default {
  actions,
  mutations,
  getStore (ajax) {
    const request = _ajax(ajax)
    let storeMap = {
      common,
      sys,
      dataview,
      notice,
      userGroup,
      analysis,
      visualizer,
      userInfo
    }
    let store = {}
    for (let name in storeMap) {
      store[util.toCamel('biz_' + name)] = storeMap[name](request)
    }
    return store
  }
}
